// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk/" + {"159":"lang/Shell-ts","184":"lang/English-ts","227":"lang/Korean-ts","273":"lang/Ngrams-ts","330":"lang/Chinese-ts","410":"lang/Japanese-ts","683":"lang/Numpad-ts","704":"lang/defs-Chinese-ts","858":"lang/Emote-ts","885":"lang/defs-English100-ts"}[chunkId] + ".js";
};